var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "192mm",
    height: "154mm",
    viewBox: "0 0 192 154",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.8881 0 0 3.9726 -310.9 -308.97)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.99999 0 0 1 .0014977 -4.8337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m112.54 83.492s11.074 8.9802 11.074 27.291h-4.3988",
    fill: "none",
    stroke: "#c41d37",
    strokeLinecap: "round",
    strokeWidth: 1.765
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.2 110.79s1.2135-12.567-9.8094-23.59l-2.854 2.7679",
    fill: "none",
    stroke: "#f15522",
    strokeLinecap: "round",
    strokeWidth: 1.765
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#c41d37"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 111.45,
    cy: 105.79,
    r: 2.744
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.71,
    cy: 97.282,
    r: 1.1346
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.95,
    cy: 106.49,
    r: 1.1346
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.18,
    cy: 100.66,
    r: 2.5005
  })), /*#__PURE__*/React.createElement("path", {
    d: "m96.14 101.53-5.6519 5.6513a4.1507 4.1507 0 0 0 3.6158 2.1162 4.1507 4.1507 0 0 0 4.1507-4.1506 4.1507 4.1507 0 0 0-2.1146-3.6168z",
    fill: "#f59628"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.2 92.375-18.373 18.403h29.566s0.92827-11.818-8.8705-20.784",
    fill: "none",
    stroke: "#f5962a",
    strokeLinecap: "round",
    strokeWidth: 1.765
  }), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.96802 1.033)",
    x: 82.154915,
    y: 117.28564,
    fill: "#bd2345",
    fontSize: "7.9935px",
    strokeLinecap: "round",
    strokeWidth: 4.4437,
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 82.154915,
    y: 117.28564,
    fill: "#bd2345",
    strokeWidth: 4.4437
  }, "Chez Ginette"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.81cf3661c3ea50b5ce1c315b638c6a4b.svg";
export { ForwardRef as ReactComponent };